import React from 'react';

import AppointmentTabs from '../Components/AppointmentTabs';
import { enhance } from './enhance';

export default enhance(AppointmentTabs);



// WEBPACK FOOTER //
// ./src/components/Healthboard/AppointmentListTabs/index.jsx